let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eP6qD")).then(() => parcelRequire('6VJF5'));